module.exports = __webpack_public_path__ + "img/oil.bb96a038.svg";